module.exports = __webpack_public_path__ + "static/media/dalton_silverman.03c7fd07.png";